<template>
  <RouterView />
  <Toasts />
</template>
<script setup>
import { RouterView } from "vue-router";
import { inject } from "vue";
import brandconfig from "@/brandconfig";
import { useBrand } from "@/composable/brand";
import { Toasts } from "@xs2event/js-lib/toast";
import { useVersionChecker } from "@/helpers/version.tsx";

useVersionChecker();

const { primary, fontFamily } = useBrand();

if (brandconfig.GA_ID) {
  inject("gtag");
}
</script>

<style scoped>
* {
  --color-primary: v-bind(primary);
}

:first-child {
  font-family: v-bind(fontFamily);
}
</style>
